module.exports = __webpack_public_path__ + "img/icon_girl.383a4cc0.png";